import script from "./ArResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ArResultsView.vue?vue&type=script&setup=true&lang=js"

import "./ArResultsView.vue?vue&type=style&index=0&id=65c6fc89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c6fc89"]])

export default __exports__